import { Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';

export const HomeRoutingModule: Routes = [{ path: 'home', component: HomeComponent }];
